import React, { useEffect, useState } from 'react';
import faqCont from '../../assets/faq_cont.png';
import faqData from '../../config/faqData';

import './FaqSection.css';


/**
 * FAQ Section
 * - Extracted from Home.js
 * - Keeps original AOS animations intact
 * - Self-contained & reusable
 */
const FaqSection = () => {
  const [activeTopic, setActiveTopic] = useState('concerns');

  useEffect(() => {
    // FAQ expand / collapse logic (kept identical to original)
    const handleFaqClick = (e) => {
      const faqItem = e.currentTarget.closest('.faq-item');
      const isActive = faqItem.classList.contains('active');

      document.querySelectorAll('.faq-item').forEach(item => {
        item.classList.remove('active');
      });

      if (!isActive) {
        faqItem.classList.add('active');
      }
    };

    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(q => q.addEventListener('click', handleFaqClick));

    return () => {
      faqQuestions.forEach(q => q.removeEventListener('click', handleFaqClick));
    };
  }, []);

  const handleImageClick = () => {
    window.open('https://t.me/lunasearch', '_blank');
  };

  return (
    <div className="faq-section" id="faq">
      <div className="faq-header">
        <h1
          data-aos="fade-down"
          data-aos-duration="600"
        >
          Frequently Asked Questions
        </h1>

        <p
          data-aos="fade-right"
          data-aos-duration="600"
          data-aos-delay="150"
        >
          Find answers to common questions about LunaSearch, our features, and how to get started.
        </p>

        <div className="faq-topics">
          <button
            className={`faq-topic ${activeTopic === 'concerns' ? 'active' : ''}`}
            onClick={() => setActiveTopic('concerns')}
          >
            Concerns
          </button>

          <button
            className={`faq-topic ${activeTopic === 'general' ? 'active' : ''}`}
            onClick={() => setActiveTopic('general')}
          >
            General
          </button>
        </div>
      </div>

      <div className="faq-content">
        <div className="faq-container">
          <div className="faq-divider"></div>

          {faqData[activeTopic].map((item, index) => (
            <div
              className="faq-item"
              key={index}
              data-aos="fade-up"
              data-aos-duration="500"
              data-aos-delay={index * 100}
            >
              <div className="faq-question">
                <h2>{item.question}</h2>
                <span className="faq-toggle"></span>
              </div>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div
          className="faq-image"
          data-aos="fade-left"
          data-aos-duration="500"
          data-aos-delay="300"
          onClick={handleImageClick}
        >
          <img src={faqCont} alt="FAQ Illustration" />
        </div>
      </div>
    </div>
  );
};

export default FaqSection;